(function ($) {
  'use strict';

  function fetchPosts(data, succesCB) {
    var $ajaxLoader = $('<div id="loading"></div>');

    $('section.overview .overview-items').before($ajaxLoader);

    $.get(ajax_props.ajaxurl, data)
      .success(function (response) {
        $('#loader').remove();
        succesCB(response);
      })
      .fail(function (error) {
        $('#loading').fadeOut(1000);
        setTimeout(function(){
          $('#loading').remove();
        }, 1000);
      });
  }
  module.exports = fetchPosts;

}(jQuery));
